// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, "/*! mixins */.auth-blitz-frame[data-v-24dcb07e]{display:block;flex:1;width:100%;min-height:0;border:0}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
